//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HAS_BLED',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
        item8: '0',
        item9: '0',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6 + form.item7 + form.item8 + form.item9
      self.hasScore = true
      console.log(result);
      if (result < 3) {
        self.descTxt = ''
      } else {
        self.descTxt = '高危'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/HAS_BLED.vue